// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"header__wrapper--2nDUP","content":"header__content--BBdev","title":"header__title--YuWkn","mobileTitle":"header__mobileTitle--1XeOx","active":"header__active--3qNiZ"};